import React, { useState, useContext, useEffect, DragEvent } from 'react';
import { Context } from "routes/private/Editor/Context";
import { IProps } from './types';
import * as S from './styles';

const DragElement: React.FC<IProps> = (props) => {

  const context = useContext(Context);

  const handleDragStart = (e: DragEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    let elementCoorsPercentage = {
      x: (e.clientX - rect.x) / rect.width,
      y: (e.clientY - rect.y) / rect.height
    };
    let data = { id: props.id, type: props.type, elementCoorsPercentage, data: props.data, itemData: props.itemData };
    if (props.type === "Image") {
      let element = e.currentTarget;
      element.classList.add("dragged");
    } else {
      let element = e.currentTarget?.cloneNode(true) as HTMLElement;
      element.id = `${props.id}-shadow`;
      element.style.position = `fixed`;
      element.style.top = `-1000px`;
      element.style.height = `${rect.height}px`;
      element.style.width = `${rect.width}px`;
      element.style.backgroundColor = `#00000000`;
      document.body.appendChild(element);
      e.dataTransfer.setDragImage(element, (e.clientX - rect.x), (e.clientY - rect.y));
    }
    e.dataTransfer.setData("text/plain", JSON.stringify(data));
    e.dataTransfer.effectAllowed = "move";
    context.onDraggingNewElement(true);
  }

  const handleDragEnd = (e: DragEvent<HTMLDivElement>) => {
    if (props.type !== "Image") {
      var element = document.getElementById(`${props.id}-shadow`);
      if (element?.parentNode) element.parentNode.removeChild(element);
    }
    e.currentTarget.classList.remove("dragged");
    context.onDraggingNewElement(false);
  }

  return (
    <S.Root
      id={props.id}
      style={props.style}
      draggable="true"
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
    >
      {props.children}
    </S.Root>
  );
}

export default DragElement;